<template>
  <div class="comp-list-con-div">
    <div class="comp-list-con">
      <div class="prod-list-block"  v-for="(item, index) of dataList" :key="index">
      <card-list
        :data="item"
        type="comp"
      >
        <template #footer>
          <div class="edit-view">
            <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#ffffff"></svg-drag></i>
            <i title="删除" class="el-icon-delete" @click.prevent="del(item)" v-if="isCanEdit"></i>
          </div>
        </template>
      </card-list>
      </div>
      <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
    </div>
  </div>
</template>

<script>
import CardList from "@/components/card-list.vue";
import SvgDrag from '@/components/svg/drag.vue';

export default {
  components: { SvgDrag, CardList },
  props: {
    dataList: { default: [] },
    isCanEdit: { default: true }
  },
  methods: {
    del(row) {
      this.$emit('del', row);
    }
  }
}
</script>

<style lang="less" scoped>

.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
    min-width: 100%;
  }
}
.comp-list-con-div{
  flex: 1;
  height: calc(100vh - 20px - 43px);
  overflow-y: auto;
}
.comp-list-con{
  display: flex;
  flex-wrap: wrap;
  padding: 10px 5px;
  flex: 1;
}
.edit-view{
  position: absolute;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  opacity: 0;
  transform: translateY(26px);
  transition: all 0.4s;
  i{
    width: 26px;
    height: 26px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .exist-span{
    width: 120px;
    height: 26px;
    color: #fff;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag-edit{
    cursor: move;
  }
}
.comp-list-con{
  /deep/ .list-card:hover .edit-view{
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
